(function() {
    $(document).ready(function() {
        // Variant inputs selector:
        const inputsSelector = "input[type='radio'][name='id']";

        // When the customer selects a variant, set the variant title
        $(inputsSelector).on("change", function() {
            const $target = $(this);

            if(!$target.is(":checked")) {
                return;
            }

            const data = $target.data();

            const $container = $target.closest(".grid-item-column");
            const $titleContainer = $container.find(".selected-variant-title");

            $titleContainer.text(data.variantTitle);
        });

        // Set the variant title on page load
        $(inputsSelector).trigger("change");
    });
})();